
<div bsModal #loginModal="bs-modal" class="modal fade" [config]="{backdrop: false}" tabindex="-1" role="dialog" aria-labelledby="loginLabel" aria-hidden="true">
  <app-login-form
    [loginVisible] = "loginVisible"
    (sendResult)="onResult($event[0])"
    (sendSignup)="onSignup($event[0])"
    (modalClosed)="closeModal($event)"
    (socialLogin)="socialLogin($event)"
    (sendNewPassword)="onChangePassword($event[0])"
    ></app-login-form>
</div><!-- /.modal -->

<div *ngIf="isMobile()" id="mobile-form" class="overlay">
    <app-login-form-mobile
      [loginVisible] = "loginVisible"
      (sendResult)="onResult($event[0])"
      (sendSignup)="onSignup($event[0])"
      (modalClosed)="closeModal($event)"
      (socialLogin)="socialLogin($event)"
      (sendNewPassword)="onChangePassword($event[0])"
    ></app-login-form-mobile>
</div>
